import { IconChevronDown, IconChevronRight, IconMoreHorizontal } from '@bitrise/bitkit-v2';

import defaultIcon from '@/assets/step-icon-default.svg';
import FormattedLog from '@/components/LogViewer/old/FormattedLog';
import { GroupOfLines } from '@/utils/buildLog';

import { StepLogChunkLogLevel } from '../../types/StepLogResponse';

type BuildLogStepProps = {
  group: GroupOfLines;
  index: number;
  isOpen: boolean;
  onStepToggleClick: (index: number, isOpen: boolean) => void;
};

const StreamingBuildLogStep = ({ group, index, isOpen, onStepToggleClick }: BuildLogStepProps) => {
  const headerFirstLine = group.stepInfo?.headerFirstLine || '';
  const lines = group.lines || [''];
  const footerLines = group.stepInfo?.footerLines || [''];

  return (
    <div className="step">
      <button className="step__toggle-button" onClick={() => onStepToggleClick(index, isOpen)} type="button">
        {isOpen ? <IconChevronDown role="presentation" /> : <IconChevronRight role="presentation" />}
        <span
          className={`step__icon ${group.stepInfo?.isUpdateAvailable ? 'update-available' : ''}`}
          role="presentation"
          style={{
            backgroundImage: `url(${group.stepInfo?.iconURL ?? defaultIcon})`,
          }}
        />
      </button>
      {!isOpen && (
        <>
          <FormattedLog
            paddingLeft={48}
            paddingRight={0}
            messages={[{ level: StepLogChunkLogLevel.Normal, message: `${headerFirstLine}\n${footerLines[0]}` }]}
          />
          <button className="step__open-button" onClick={() => onStepToggleClick(index, isOpen)} type="button">
            <IconMoreHorizontal />
          </button>
        </>
      )}

      <FormattedLog
        paddingLeft={48}
        paddingRight={0}
        messages={[
          {
            level: StepLogChunkLogLevel.Normal,
            message: isOpen ? lines.join('\n') : `${footerLines.join('\n')}`,
          },
        ]}
      />
    </div>
  );
};

export default StreamingBuildLogStep;
